import {GenesisModal} from 'extensions/g-modal';
import styles from './chat-widget-modal.component.scss?as=stylesheet';
import {defineCustomElement} from 'extensions/utils';

export class ChatWidgetModal extends GenesisModal {

	static get styles () {
		return [
			...super.styles,
			styles
		];
	}

	constructor () {
		super();
	}

	beforeOpen () {
		super.beforeOpen();

		// Track Talk to An Expert Modal Opening
		window.dataLayer = window.dataLayer || [];
		window.dataLayer.push({
			event: 'ga_event',
			/* eslint-disable camelcase */
			ga_event_action: 'Click',
			ga_event_category: 'Ring Builder',
			ga_event_label: 'Talk to an Expert',
			ga_event_non_interaction: false
			/* eslint-enable camelcase */
		});
	}

};

defineCustomElement('rb-chat-widget-modal', ChatWidgetModal);
